import { inject } from '@angular/core';
import {
  type ActivatedRouteSnapshot,
  type CanActivateFn,
  Router,
  type RouterStateSnapshot,
  type UrlTree,
} from '@angular/router';
import { type AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { environment } from '../../../environments/environment';

/**
 * Authentication guard with group verification
 * Checks if the user is authenticated and belongs to the stefconnect/admin group
 * Redirects to Keycloak SSO with idpHint for IDP routing
 */
const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  authData: AuthGuardData,
): Promise<boolean | UrlTree> => {
  const { authenticated, keycloak } = authData;
  const router = inject(Router);

  if (!authenticated) {
    // Redirect to login if not authenticated, with idpHint for IDP routing
    await keycloak.login({
      redirectUri: globalThis.location.href,
      idpHint: environment.keycloak.idpHint,
    });
    return false;
  }

  // Check if user belongs to stefconnect/admin group
  const groups = keycloak.tokenParsed?.['groups'] as string[] | undefined;
  const hasAdminAccess = groups?.includes('/stefconnect/admin') ?? false;

  if (!hasAdminAccess) {
    // Display error message and logout
    alert('Accès refusé. Vous devez appartenir au groupe stefconnect/admin.');
    await keycloak.logout();
    return false;
  }

  return true;
};

export const authGuard = createAuthGuard<CanActivateFn>(isAccessAllowed);
